module.exports = __webpack_public_path__ + "9b8bf13e9f71d8e1c8d468837f83c460.jpg";